import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export default function LightboxModal({ isOpen, image, title, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="lightbox-modal-overlay"
        >
          <motion.div
            className="relative w-full max-w-3xl overflow-hidden rounded-2xl border border-white/30 bg-white shadow-2xl"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.28, ease: "easeOut" }}
            data-testid="lightbox-modal-content"
          >
            <button
              onClick={onClose}
              className="absolute right-3 top-3 z-10 rounded-full bg-[#1a1a1a] p-2 text-white transition-colors hover:bg-[#333333]"
              data-testid="lightbox-close-button"
              aria-label="Close image preview"
            >
              <X className="h-4 w-4" />
            </button>
            <img
              src={image}
              alt={title}
              className="max-h-[75vh] w-full object-contain"
              data-testid="lightbox-modal-image"
            />
            <p
              className="border-t border-[#f2e6c9] px-5 py-4 font-[Manrope] text-sm text-[#333333]"
              data-testid="lightbox-modal-caption"
            >
              {title}
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
